import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";
import Loc from "../services/localization";
import CONFIG_COMPANY from "../services/myConfig";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'date', 'type', 'data'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            title: '',
            users: [],
            hasError: '',
            currentDate: '',
            filter: '',
            trainings: [],
            showChooseButton: true,
            dataToEdit: null,

            categories: [],
            showAddCategory: false,
            newCategory: '',
            selectedCategory: "null",
            isLoadingCategory: false,

            trainingMeasures: [],
            showAddMeasures: false,
            newMeasure: '',
            selectedMeasure: "null",
            isLoadingMeasure: false,


            model: {
                type: '',
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                coachNotes: '',
                trainingType: '',
                category: '',
                resultMeasure: null,
                resultRounds: null,
                advanceOptions: null,
                sortType: 'ASC'
            },
            selectedLanguageIndex: 0,
            languages: [
                {
                    id: 'sr',
                    name: 'Srpski',
                },
                {
                    id: 'en',
                    name: 'English',
                },
            ],
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                if(CONFIG_COMPANY.LANGUAGES != null){
                    this.languages = CONFIG_COMPANY.LANGUAGES;
                }
                this.model.type = this.type;
                this.dataToEdit = this.data;
                this.title = this.dataToEdit == null ? LocService.t('label_add_td') : LocService.t('label_edit_td')
                if(this.dataToEdit != null){
                    this.model.id =  this.dataToEdit.id
                    this.model.name = this.dataToEdit.name
                    this.model.enName = this.dataToEdit.enName
                    this.model.shortDescription = this.dataToEdit.shortDescription
                    this.model.enShortDescription = this.dataToEdit.enShortDescription
                    this.model.longDescription = this.dataToEdit.longDescription
                    this.model.enLongDescription = this.dataToEdit.enLongDescription
                    this.model.trainingType = this.dataToEdit.trainingType
                    this.model.category = this.dataToEdit.category
                    this.model.coachNotes = this.dataToEdit.coachNotes
                    this.model.resultMeasure = this.dataToEdit.resultMeasure
                    this.model.resultRounds = this.dataToEdit.resultRounds
                    this.model.advanceOptions = this.dataToEdit.advanceOptions
                    this.model.sortType = this.dataToEdit.sortType
                }
                this.getAllCategories( true)
                this.getAllMeasures( true)
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeTrainingDefinitionWod')
            this.reset();
            this.trainings = []
            this.currentDate = ''
            this.startAtTime = ''
        },
        reset: reset,
        addTraining: addTraining,
        isSelectedLanguage: isSelectedLanguage,
        getChipClassLanguage: getChipClassLanguage,
        onSelectedLanguage: onSelectedLanguage,
        editTraining: editTraining,
        getAllCategories: getAllCategories,
        deleteCategory: deleteCategory,
        addTypeCategory: addTypeCategory,
        getAllMeasures: getAllMeasures,
        addMeasure: addMeasure,
        deleteMeasure: deleteMeasure,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small modal--training-editor'
            }else {
                return 'modal--large modal--training-editor'
            }
        },
        preventClose() {
            // Prazna funkcija koja blokira zatvaranje na klik izvan modala
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: auto !important; overflow: visible;';
            }
            return 'height: auto !important; overflow: visible;';
        }

    }
}


function reset(){
    this.dataToEdit = null
    this.selectedLanguageIndex = 0;
    this.selectedCategory= "null";
    this.selectedMeasure= "null";
    this.model = {
        type: '',
        name: '',
        enName: '',
        shortDescription: '',
        enShortDescription: '',
        longDescription: '',
        enLongDescription: '',
        coachNotes: '',
        trainingType: '',
        category: null,
        resultMeasure: null,
        resultRounds: null,
        advanceOptions: null,
        sortType: 'ASC'
    }
}


function addTraining() {
    let _self = this;
    if(this.model.name == null ||
        this.model.name.length === 0){
        swal(LocService.t("label_error"), LocService.t('label_td_name_required'), 'warning')
        return;
    }
    this.model.category = this.selectedCategory != null ? this.selectedCategory.name : null;
    this.model.resultMeasure = this.selectedMeasure != null ? this.selectedMeasure.name : null;
    if(this.dataToEdit != null){
        this.editTraining();
        return;
    }
    AdminApiService.addNewTrainingDefinition(this.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_success_added_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinitionWod')
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function editTraining() {
    let _self = this;
    AdminApiService.editTrainingDefinition(this.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_success_edited_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinitionWod')
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function isSelectedLanguage(item, index){
    return this.selectedLanguageIndex === index
}

function getChipClassLanguage(item, index) {
    if (this.selectedLanguageIndex === index) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function onSelectedLanguage(item, index){
    this.selectedLanguageIndex = index
}

function getAllCategories(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("WOD_CATEGORY")
        .then((response) => {
            _self.categories = response.data
            _self.isLoadingCategory = false
            _self.showAddCategory = false;
            if(firstTime){
                var filtered = _self.categories.filter(c => c.name === _self.model.category)
                if(filtered.length > 0){
                    _self.selectedCategory = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoadingCategory = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function getAllMeasures(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("WOD_MEASURE")
        .then((response) => {
            _self.trainingMeasures = response.data
            _self.isLoadingMeasure = false
            _self.showAddMeasures = false;
            if(firstTime){
                var filtered = _self.trainingMeasures.filter(c => c.name === _self.model.resultMeasure)
                if(filtered.length > 0){
                    _self.selectedMeasure = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function addTypeCategory(){
    let _self = this;
    let model = {
        name: _self.newCategory,
        type: "WOD_CATEGORY"
    }
    if(model.name.length === 0) return;
    _self.isLoadingCategory = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllCategories(false);
            _self.newCategory = ""
        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function addMeasure(){
    let _self = this;
    let model = {
        name: _self.newMeasure,
        type: "WOD_MEASURE"
    }
    if(model.name.length === 0) return;
    _self.isLoadingMeasure = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.newMeasure = ""
        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteCategory(){
    let _self = this;
    if(this.selectedCategory == null) return;
    _self.isLoadingCategory = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedCategory.id)
        .then((response) => {
            _self.getAllCategories(false);
            _self.selectedCategory = "null"

        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteMeasure(){
    let _self = this;
    if(this.selectedMeasure == null) return;
    _self.isLoadingMeasure = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedMeasure.id)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.selectedMeasure = "null"

        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/modals/AddTrainingDefinitionWod.js